import axios from "axios";

// Use REACT_APP_BACKEND_URL when provided; fall back to same-origin so the
// ingress (which routes /api/* to the backend) handles requests automatically.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
});

// Inject active company header + bearer token from localStorage on every request
api.interceptors.request.use((cfg) => {
    if (typeof window !== "undefined") {
        const cid = localStorage.getItem("active_company_id");
        // A request that names its own company (the approvals inbox acting on another company's item)
        // keeps it; everything else goes to the company the screen is on.
        const explicit = cfg.headers && (typeof cfg.headers.get === "function" ? cfg.headers.get("X-Company-Id") : cfg.headers["X-Company-Id"]);
        if (cid && !explicit) cfg.headers["X-Company-Id"] = cid;
        const tok = localStorage.getItem("access_token");
        if (tok) cfg.headers["Authorization"] = `Bearer ${tok}`;
    }
    return cfg;
});

export default api;

export const formatPHP = (n) => {
    const x = Number(n || 0);
    return new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP", minimumFractionDigits: 2 }).format(x);
};

export const formatDate = (s) => {
    if (!s) return "—";
    try {
        return new Date(s).toLocaleDateString("en-PH", { year: "numeric", month: "short", day: "2-digit" });
    } catch { return s; }
};

export const formatDateTime = (s) => {
    if (!s) return "—";
    try {
        return new Date(s).toLocaleString("en-PH", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    } catch { return s; }
};

export const formatErrorDetail = (detail) => {
    if (detail == null) return "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e?.msg || JSON.stringify(e))).join(" ");
    if (detail?.msg) return detail.msg;
    return String(detail);
};
